import { useContext } from "react";
import { CustomModal, UserInformation } from "../../../../components";
import Context from "../../../../context";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import TitleLine from "../../../../components/TitleLine";
import CustomLeaflet from "../../../../components/CustomLeaflet";

const Detail = () => {
  const { setShowModal, showModal, selectedCompany } = useContext(
    Context?.CompanyScreen
  );
  return (
    <>
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DETAIL"}
        minWidth={"30vw"}
        maxWidth={"35vw"}
      >
        <Row className="modal-user-info">
          <Column>
            <UserInformation
              avatar={selectedCompany?.logo}
              name={selectedCompany?.firstName}
              lastName={selectedCompany?.lastName}
              phoneNumber={selectedCompany?.phoneNumber}
            />
          </Column>
        </Row>
        <TitleLine title="" />
        <Row className="modal-user-info">
          <Column>
            <CustomLeaflet
              defaultLat={selectedCompany?.lat}
              defaultLng={selectedCompany?.lng}
              defaultLatArea={selectedCompany?.lat}
              defaultLngArea={selectedCompany?.lng}
            />
          </Column>
        </Row>
      </CustomModal>
    </>
  );
};

export default Detail;
